import urlParse from 'url-parse';

import { Check, FormValue } from 'lib/utils/formValidation/formValidation';

/*
  React semantics make empty inputs that are controlled components have a value of "".
  Therefore we have to check for both nullish values and the empty string.
  Additionally, we should add empty array, empty object, etc. as needed.

  MOST rules should early exit and NOT FAIL if they receive an empty value.
  This is because failing on an empty value is implicitly treating a field as required.
 */
const isValidUrl: Check = (value: FormValue | null): boolean => {
  // The second argument is the base URL. If value has no protocol it is
  // assumed to be a sub-path, and the library uses the current browser path as
  // the base path, which automatically prepends https://. The docs specify
  // passing {} as the second argument to avoid this.
  // Ref: https://github.com/unshiftio/url-parse#usage -- end of section

  // Whitespace check, because urlParse strips it
  if (/\s/.test(value as string)) {
    return false;
  }
  const parsedUrl = urlParse(value as string, {});
  return parsedUrl.protocol === 'https:' && parsedUrl.host !== '';
};

export default isValidUrl;
